/**
 * Redux action, который запрашивает застройщиков с текущем состоянием фильтров
 */
import { selectFilters } from '../../selectors/filters';
import { TThunkAction } from '../../types/redux';
import { getBuildersInfo } from '../../services/builders';
import { buildersInfoRequest, buildersInfoSuccess, buildersInfoFailure } from './actions';
import { updateBrowserHistory } from '../browserHistory';
import { IFilters } from '../../types/filters';
import { scrollTop } from '../../utils/scroll';

export const fetchBuildersInfo =
  (filters?: IFilters, historyUrl?: string): TThunkAction<Promise<void>> =>
  async (dispatch, getState, { logger, httpApi, custom }) => {
    const { subdomain } = custom;
    const { location: regionId, ...otherFilters } = filters || selectFilters(getState());

    try {
      dispatch(buildersInfoRequest());
      scrollTop();

      const newData = await getBuildersInfo({
        httpApi,
        logger,
        parameters: {
          ...otherFilters,
          regionId,
          subdomain,
        },
      });
      dispatch(buildersInfoSuccess(newData));
      dispatch(updateBrowserHistory(historyUrl));
    } catch (e) {
      dispatch(buildersInfoFailure());

      throw e;
    }
  };
